import axios from '../../../configs/axios';

export default {
  fetchReports(requestParams) {
    const params = {
      request: {
        assets: {
          market_reports: {
            assets: ['reports'],
            filters: requestParams.filters,
          },
        },
      },
    };

    return axios.get('/my_research/data.json', { params });
  },
  shareReport(data) {
    return axios.post('/my_research/share', data);
  },
};
